import React, { Component, } from 'react';
import { lang } from'../Helpers/lang';
import { withRouter } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Select from 'react-select';
import $ from 'jquery';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';
/*const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };*/
class Edit extends Component {
	
	constructor(props)
	{
		super(props);
		//const id = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		const id = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;

		this.state = {
		  list_id : id,
	      login_type:'',
	      show_count_yes:true,
	      show_count_no:false,
	      name:'',
	      module_type:'',
	      module_type_value:'',
	      priorty:'',
		  content:'',
		  image_preview:'',
		  image_name:'',
		  image:'',
	      name_arr:[],
	      module_type_arr:[],
	      module_type_value_arr:[],
	      priorty_arr:[],
		  content_arr:'',
		  image_preview_arr:'',
		  image_name_arr:'',
	      showlayout: false,
	      select_options:'',
	      select_options_arr:[],
	      selectedvalue: '',
          selectedOption:{ value: 'active', label: 'Active'},
          Loading:false,
		  show_count_arr:[],
		  image_arr:[],
          editindex:'',
          field_ids:[],
		  remove_ids:'',
		  removeall_ids:'',
		  login_type:'',
		  image_name_single:'',
		  bg_image_name_arr:'',
		  bg_image_name:'',
		  bg_image_preview: '',
		  bg_image: '',
		  db_bg_image_name:'',
		  show_count: 'yes',
		   show_tooltip: 'yes',
		  	text_color: '#111111',
			text_color_arr: [],
		  	count_color: '#111111',
			count_color_arr: [],
			text_size: '',
			text_size_arr: [],
			count_size: '',
			count_size_arr: [],
			bg_image_arr:[],
			dashboard_block:'',
			dashboard_block_sel:'',
			dashboard_block_arr:[],
            show_tooltip_arr:[],
			icon_width_arr:[],
			mini_dropdown_list:false,
			blockCounts:{}
		};
    this.deletesinglefield = this.deletesinglefield.bind(this);

	var qs = require('qs');
	var listid = this.state.list_id;

	axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
		const formdata = res.data.data;
		const block1count = formdata.dashboard_block.filter(item => item === "block1").length;
        const block2count = formdata.dashboard_block.filter(item => item === "block2").length;
        const block3count = formdata.dashboard_block.filter(item => item === "block3").length;
        const block4count = formdata.dashboard_block.filter(item => item === "block4").length;
        this.setState({
			blockCounts:{
				block1:block1count,
				block2:block2count,
				block3:block3count,
				block4:block4count
			}

		})
console.log(block1count); // 1
		console.log(formdata, "formdata")
						this.setState({login_type : {value:formdata.usertype, label:formdata.usertype}, showlayout: true, login_type_value: formdata.usertype});
						
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field});
					  	}
					  	if(formdata.priority){
					  		this.setState({priorty_arr: formdata.priority});
					  	}
					  	if(formdata.select_option){
						
					  		this.setState({module_type_value_arr : formdata.select_option});
					  	}
					  	if(formdata.image){
					  		this.setState({image_name_arr: formdata.image, image_arr: formdata.image});
					  	}
					  	if(formdata.column_id){
					  		this.setState({field_ids: formdata.column_id});
					  	}
						if(formdata.mini_dropdown_list){
					  		this.setState({mini_dropdown_list: formdata.mini_dropdown_list});
					  	}
					  	if(formdata.show_count){
					  		this.setState({show_count_arr: formdata.show_count});
					  	}
						if (formdata.count_size) {
							this.setState({ count_size_arr: formdata.count_size });
						}
						if (formdata.text_color) {
							this.setState({ text_color_arr: formdata.text_color });
						}
						if (formdata.count_color) {
							this.setState({ count_color_arr: formdata.count_color });
						}
						if (formdata.text_size) {
							this.setState({ text_size_arr: formdata.text_size });
						}
						if (formdata.dashboard_block) {
							this.setState({ dashboard_block_arr: formdata.dashboard_block });
						}
						if (formdata.show_tooltip) {
							this.setState({ show_tooltip_arr: formdata.show_tooltip });
						}
						if (formdata.icon_width) {
							this.setState({ icon_width_arr: formdata.icon_width });
						}
						if (formdata.bg_image) {
							this.setState({ bg_image_arr: formdata.bg_image,bg_image_name_arr:formdata.bg_image });
						}
						

						

		
	
	}); 
 }
	
	componentDidMount() {
		  	if(localStorage.getItem("admin_id") === 'undefined' && localStorage.getItem('admin_id') === '' && localStorage.getItem('admin_id') === null){
			this.props.history.push('/');
		}
  }

  getdashbordlistdetails = () => {
	var qs = require('qs');
	var listid = this.state.list_id;

	axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
		const formdata = res.data.data;
						this.setState({login_type : {value:formdata.usertype, label:formdata.usertype}, showlayout: true, login_type_value: formdata.usertype});
						
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field});
					  	}
					  	if(formdata.priority){
					  		this.setState({priorty_arr: formdata.priority});
					  	}
					  	if(formdata.module_type){
						
					  		this.setState({module_type_value_arr : formdata.module_type});
					  	}
					  	if(formdata.image){
					  		this.setState({image_name_arr: formdata.image, image_arr: formdata.image});
					  	}
					  	if(formdata.column_id){
					  		this.setState({field_ids: formdata.column_id});
					  	}
					  	if(formdata.show_count){
					  		this.setState({show_count_arr: formdata.show_count});
					  	}

						if(formdata.mini_dropdown_list){
					  		this.setState({mini_dropdown_list: formdata.mini_dropdown_list});
					  	}
		
	
	}); 
  }
	handleInputChange = (event) =>{
    const { name, type, value, checked  } = event.target;

	const finalValue = type === "checkbox" ? checked : value;

    this.setState({ [name]: finalValue });

     if(name === 'form_column'){
       this.setState({form_one_column: !this.state.form_one_column});
       this.setState({form_two_column: !this.state.form_two_column});
    }
    if(name === 'field_required'){
        this.setState({field_required_checked: !this.state.field_required_checked});
    }
    if(name == 'select_options'){
        this.setState({select_options:value})
    }
	if (name === 'show_count') {
		this.setState({ show_count: value });
	}
	
	if (name === "mini_dropdown_list") {
    this.setState({ mini_dropdown_list: checked });
  }
  }

  handleChange = login_type => {
	this.setState({login_type})
	this.setState({  login_type_value : login_type.value});
};

onChangeHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	reader.onloadend = () => {
		this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			image_name_single:''
		});
	};
	reader.readAsDataURL(file);
}

removeImagePreview = () => {
	this.setState({
		image_name_single: "",
		image_preview: "" 
	});
};

removeBgImagePreview = () =>{
	this.setState({
		db_bg_image_name: "",
		bg_image_preview: "" 
	});
}

onChangeBgImgHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	console.log(file,"file")
	reader.onloadend = () => {
		this.setState({
			bg_image_name: file.name,
			bg_image_preview: reader.result,
			bg_image: file,
			db_bg_image_name:''
		});
	};
	reader.readAsDataURL(file);
}

 
 handleFormSubmit = () => {	
				this.setState({Loading:true});
				 const config = {
			        headers: {
			          'Content-Type': 'multipart/form-data'
			        }
			      };

				const formPayload = this.state;
				var qs = require('qs');
		        console.log(formPayload.icon_width_arr,"fromm");
				// var postObject = {
				// 	admin_id : localStorage.getItem("admin_id"),
				// 	list_id : this.state.list_id,
				// 	field_ids : formPayload.field_ids,
				// 	editColumnId : this.state.editFieldId,
				// 	user: formPayload.login_type_value,
				// 	name_arr: formPayload.name_arr,
				// 	module_type_value_arr: formPayload.module_type_value_arr,
				// 	priorty_arr: formPayload.priorty_arr,
				// 	show_count_arr:formPayload.show_count_arr,
				// 	content_arr: formPayload.content_arr,
				// 	removeid: formPayload.remove_ids,
				// 	removeallid: formPayload.removeall_ids,
				// 	text_size_arr: formPayload.text_size_arr,
				// 	text_color_arr: formPayload.text_color_arr,
				// 	count_color_arr: formPayload.count_color_arr,
				// 	count_size_arr: formPayload.count_size_arr,
				// 	mini_dropdown_list: formPayload.mini_dropdown_list,
				// 	dashboard_block_arr:formPayload.dashboard_block_arr,
				// 	show_tooltip_arr:formPayload.show_tooltip_arr,
				// 	icon_width_arr:formPayload.icon_width_arr,
				// 	// bg_image_name_arr:formPayload. bg_image_name_arr,
				// 	// image_name_arr:formPayload. bg_image_name_arr,
				// 	db_bg_image_name:formPayload.db_bg_image_name,
				// 	image_name_single:formPayload.image_name_single

				// };
				var postObject = {
    admin_id : localStorage.getItem("admin_id"),
    list_id : this.state.list_id,
    field_ids : formPayload.field_ids,
    editColumnId : this.state.editFieldId,
    user: formPayload.login_type_value,
    name_arr: formPayload.name_arr,
    module_type_value_arr: formPayload.module_type_value_arr,
    priorty_arr: formPayload.priorty_arr,
    show_count_arr:formPayload.show_count_arr,
    content_arr: formPayload.content_arr,
    removeid: formPayload.remove_ids,
    removeallid: formPayload.removeall_ids,
    text_size_arr: formPayload.text_size_arr,
    text_color_arr: formPayload.text_color_arr,
    count_color_arr: formPayload.count_color_arr,
    count_size_arr: formPayload.count_size_arr,
    mini_dropdown_list: formPayload.mini_dropdown_list,
    dashboard_block_arr:formPayload.dashboard_block_arr,
    show_tooltip_arr:formPayload.show_tooltip_arr,
    icon_width_arr:formPayload.icon_width_arr,
    db_bg_image_name:formPayload.db_bg_image_name,
    image_name_single:formPayload.image_name_single,
    
    // ✅ NEW JSON with current edit values
    current_edit_values: JSON.stringify({
        name: this.state.name,
        priorty: this.state.priorty,
        link_page: this.state.module_type_value,
        dashboard_block: this.state.dashboard_block,
        show_tooltip: this.state.show_tooltip,
        icon_width: this.state.icon_width,
        text_color: this.state.text_color,
        text_size: this.state.text_size,
        count_color: this.state.count_color,
        count_size: this.state.count_size,
        content: this.state.content,
        show_count: this.state.show_count
    })
};

				//this.props.getEditForm(qs.stringify(postObject));
				
				let formData = new FormData();
				for (let key in postObject) {
					formData.append(key, postObject[key]);
				}

				// var filesdata = this.state.image_arr;

				// console.log(filesdata, "filesdata123")

				// if (formData.name_arr && Array.isArray(formData.name_arr)) {
				// 	formData.name_arr.forEach((row, index) => {
				// 		if (filesdata && filesdata[index]) {
				// 			formData.append(`update_image[${index}]`, filesdata[index]);
				// 		}
				// 	});
				// }

				if (this.state.image) {
					formData.append("update_image", this.state.image);
				}

				if (this.state.bg_image) {
					formData.append("update_bgimage", this.state.bg_image);
				}

				axios.post(apiUrl+"dashboardmanagment/edit",formData,config).then(res => {
					if(res.data.status === "success"){
							$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
									setTimeout(
									function() {
										// $('.success_message').html(this.props.history.push('/dashboardmanagement'));
										$('.success_message').html('');
										this.getdashbordlistdetails();
										this.setState({Loading:false});
									}
									.bind(this),
									3000
									);
						}else{
							$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
							
							setTimeout(
							function() {
								$('.success_message').html('');
							}
							.bind(this),
							3000
							);
						}
					});

	}


  Addtolayout=()=>{

	  	var showcount;
		if(this.state.show_count_yes == true){
			showcount = 'yes';
		}else{
			showcount = 'no';
		}
  		var Index = this.state.editindex;
		
		let fieldname = [...(Array.isArray(this.state.name_arr) ? this.state.name_arr : [])];
		let fieldtype = [...(Array.isArray(this.state.module_type_value_arr) ? this.state.module_type_value_arr : [])];
		let priority = [...(Array.isArray(this.state.priorty_arr) ? this.state.priorty_arr : [])];
		let content = [...(Array.isArray(this.state.content_arr) ? this.state.content_arr : [])];
		let image = [...(Array.isArray(this.state.image_arr) ? this.state.image_arr : [])];
		let count_size = [...(Array.isArray(this.state.count_size_arr) ? this.state.count_size_arr : [])];
		let text_color = [...(Array.isArray(this.state.text_color_arr) ? this.state.text_color_arr : [])];
		let count_color = [...(Array.isArray(this.state.count_color_arr) ? this.state.count_color_arr : [])];
		let text_size = [...(Array.isArray(this.state.text_size_arr) ? this.state.text_size_arr : [])];
		let bg_image = [...(Array.isArray(this.state.bg_image_arr) ? this.state.bg_image_arr : [])];
		let dashboard_block = [...(Array.isArray(this.state.dashboard_block_arr) ? this.state.dashboard_block_arr : [])];
		let show_tooltip = [...(Array.isArray(this.state.show_tooltip_arr) ? this.state.show_tooltip_arr : [])];
		let icon_width = [...(Array.isArray(this.state.icon_width_arr) ? this.state.icon_width_arr : [])];
		let show = [...(Array.isArray(this.state.show_count_arr) ? this.state.show_count_arr : [])];
		let mini_dropdown_list = [...(Array.isArray(this.state.mini_dropdown_list) ? this.state.mini_dropdown_list : [])]; 
		if(Index !==''){
		     console.log("editt");
			fieldname.splice(Index, 1,this.state.name);
			fieldtype.splice(Index, 1,this.state.module_type_value);
			priority.splice(Index, 1,this.state.priorty);
			content.splice(Index, 1,this.state.content);
			image.splice(Index,1,this.state.image);
			count_size.splice(Index, 1, this.state.count_size);
			text_color.splice(Index, 1, this.state.text_color);
			count_color.splice(Index, 1, this.state.count_color);
			text_size.splice(Index, 1, this.state.text_size);
			show.splice(Index,1,show);
			console.log("About to store dashboard_block value:", this.state.dashboard_block);
			dashboard_block.splice(Index, 1, this.state.dashboard_block);
			console.log("Dashboard_block array after splice:", dashboard_block);
			show_tooltip.splice(Index,1,this.state.show_tooltip);
			icon_width.splice(Index,1,this.state.icon_width);
			bg_image.splice(Index,1,this.state.bg_image);
			this.setState({name_arr: fieldname,module_type_value_arr: fieldtype,content_arr:content,priorty_arr:priority,image_arr:image,show_count_arr:show, count_size_arr: count_size, text_color_arr: text_color, count_color_arr : count_color, text_size_arr: text_size, mini_dropdown_list: mini_dropdown_list,
				dashboard_block_arr:dashboard_block,show_tooltip_arr:show_tooltip,icon_width_arr:icon_width,bg_image_arr:bg_image
			});

			console.log(this.state.dashboard_block_arr, "this.state.image_arr");
		}else{
			console.log("Adding NEW entry - dashboard_block value:", this.state.dashboard_block);
			this.setState({
				name_arr: this.state.name_arr.concat(this.state.name), module_type_value_arr: this.state.module_type_value_arr.concat(this.state.module_type_value),
				priorty_arr: this.state.priorty_arr.concat(this.state.priorty),content_arr: this.state.content_arr.concat(this.state.content),image_arr: this.state.image_arr.concat(this.state.image),
				count_size_arr: this.state.count_size_arr.concat(this.state.count_size),
				text_color_arr: this.state.text_color_arr.concat(this.state.text_color),
				count_color_arr: this.state.count_color_arr.concat(this.state.count_color),
				text_size_arr: this.state.text_size_arr.concat(this.state.text_size),

				bg_image_arr: this.state.bg_image_arr.concat(this.state.bg_image),
				dashboard_block_arr: this.state.dashboard_block_arr.concat(this.state.dashboard_block),
				show_tooltip_arr: this.state.show_tooltip_arr.concat(this.state.show_tooltip),
				icon_width_arr: this.state.icon_width_arr.concat(this.state.icon_width),
				}, () => {
					console.log("After adding new entry - dashboard_block_arr:", this.state.dashboard_block_arr);
				});
				// if(this.state.show_count_yes == true){
				// 	var show_count = 'yes';
				// }else{
				// 	var show_count = 'no';
				// }
				this.setState({show_count_arr: this.state.show_count_arr.concat(this.state.show_count)})
				this.setState({mini_dropdown_list: this.state.mini_dropdown_list.concat(this.state.mini_dropdown_list)})
		}
	    
	
		this.setState({showlayout: true},function(){
		//this.setState({name:'',module_type:'',module_type_value:'',priorty:'',content:'',editindex:'', text_color: '',count_color : '', text_size: '', count_size: '', dashboard_block: '', show_tooltip: 'yes', icon_width: '' });
		this.getformlayout();
		scrollToTop();
		$('#addbutton').html('Add');
		});
  }

  validateFormfield() {
		const {form_field_name,form_input_type_value,field_required,field_priorty,select_options} = this.state;
		let errors = 0;
	
		if (!form_field_name) {
			errors++;
			$('.errorfieldname').html('<span class="errorspan">Please fill the field</span>');
		}else if(form_field_name){
			$('.errorfieldname').html('');
		}


		if (!form_input_type_value) {
			errors++;
			$('.errortype').html('<span class="errorspan">Please select input type</span>');
		}else if(form_input_type_value){
			$('.errortype').html('');
		}

		if(!field_priorty){
		errors++;
			$('.errorpriority').html('<span class="errorspan">Please fill the field</span>');
		}else if(field_priorty){
			$('.errorpriority').html('');
		}

		if(form_input_type_value == 'select'){
			if(!select_options){
				errors++;
				$('.erroroptions').html('<span class="errorspan">Please fill the field</span>');
			}else if(select_options){
				$('.erroroptions').html('');
			}
		}

		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

    }

       componentWillReceiveProps(Props){

    	   if(Props.formdetail !== this.props.formdetail){
    		if(Object.keys(Props.formdetail).length > 0){
				this.setState({Loading:false});
					//console.log(Props.carlist);
					if(Props.formdetail[0].status === "success"){

						const formdata = Props.formdetail[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
					  	}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}
						if (formdata.text_size) {
							this.setState({ field_text_size_arr: formdata.text_size });
						}
						if (formdata.text_color) {
							this.setState({ field_text_color_arr: formdata.text_color });
						}
						if (formdata.count_color) {
							this.setState({ field_count_color_arr: formdata.count_color });
						}
						if (formdata.count_size) {
							this.setState({ field_count_size_arr: formdata.count_size });
						}
					}
    		}
    	}

    if(Props.formedit !== this.props.formedit){

    		if(Object.keys(Props.formedit).length > 0){

    			this.setState({ Loading: false });

    			if(Props.formedit[0].status === "success"){
    				

						const formdata = Props.formedit[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
					  	}
						if(formdata.bg_image){
					  		this.setState({bg_image_arr: formdata.bg_image});
					  	}
						if(formdata.dashboard_block){
					  		this.setState({dashboard_block_arr: formdata.dashboard_block});
					  	}
						if(formdata.show_tooltip){
					  		this.setState({show_tooltip_arr: formdata.show_tooltip});
					  	}
						if(formdata.icon_width){
					  		this.setState({icon_width_arr: formdata.icon_width});
					  	}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}
						if (formdata.count_size) {
							this.setState({ field_count_size_arr: formdata.count_size });
						}
						if (formdata.text_color) {
							this.setState({ field_text_color_arr: formdata.text_color });
						}
						if (formdata.count_color) {
							this.setState({ field_count_color_arr: formdata.count_color });
						}
						if (formdata.text_size) {
							this.setState({ field_text_size_arr: formdata.text_size });
						}

					  	$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
	                	scrollToTop();
	    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					
    			}else{
    			$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
                	scrollToTop();
    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    		 }
    	}
    }
  }
  deletesinglefield(Index, id){
      let fieldname = [...this.state.name_arr];
      let fieldtype = [...this.state.module_type_value_arr];
      let showcount = [...this.state.show_count_arr];
      let fieldpriorty = [...this.state.priorty_arr]; 
	  let content = [...this.state.content_arr]; 
      let fieldids = [...this.state.field_ids]; 
	  	let fieldtext_size = [...this.state.text_size_arr];
		let fieldtext_color = [...this.state.text_color_arr];
		let fieldcount_color = [...this.state.count_color_arr];
		let fieldcount_size = [...this.state.count_size_arr];
      fieldname.splice(Index, 1);
      fieldtype.splice(Index, 1);
      showcount.splice(Index, 1);
      fieldpriorty.splice(Index, 1);
      content.splice(Index, 1);
      fieldids.splice(Index, 1);
	  	fieldtext_size.splice(Index, 1);
		fieldcount_color.splice(Index, 1);
		fieldcount_size.splice(Index, 1);
      this.setState({name_arr: fieldname,module_type_value_arr: fieldtype,show_count_arr:showcount,priorty_arr:fieldpriorty,content_arr:content,field_ids:fieldids,
			count_size_arr: fieldcount_size,
			count_color_arr: fieldcount_color,
			text_size_arr: fieldtext_size
		});
	  this.setState(prevState => ({
		remove_ids: [...prevState.remove_ids, id]
	  }))
  }
  editsinglefield = (index) => {
	   const editData = this.state.field_ids[index];
	   console.log(editData, "editData1234");
		$('.error_name').html('');
		$('.error_module_type_value').html('');
		$('.error_priorty').html('');
		$('.error_count_size').html('');
		$('.error_text_color').html('');
		$('.error_count_color').html('');
		$('.error_text_size').html('');
	
  		this.setState({name:this.state.name_arr[index],priorty:this.state.priorty_arr[index],content: this.state.content_arr[index],editindex: index,
			editFieldId: editData,
			text_color: this.state.text_color_arr[index],
			count_color: this.state.count_color_arr[index],
			count_size: this.state.count_size_arr[index],
			text_size: this.state.text_size_arr[index],
			content: this.state.content_arr[index],
			dashboard_block: this.state.dashboard_block_arr[index],
			show_tooltip: this.state.show_tooltip_arr[index],
			icon_width: this.state.icon_width_arr[index]
		});

  		var fieldtype = this.state.module_type_value_arr[index];

  		// var fieltypeval =fieldtype.charAt(0).toUpperCase() + fieldtype.slice(1);
  		
  		// this.setState({form_input_type: {value: fieldtype, label: fieltypeval},form_input_type_value: fieldtype});
		  var contr =[];
		//   for(let i=0; i<lang.common.dashboard_field_options.length; i++){
		//   if(lang.common.dashboard_field_options[i].value == this.state.module_type_value_arr[index]){
		//  	 contr.push(lang.common.dashboard_field_options[i])
		//   }
		//   }
		//   this.setState({module_type: contr,module_type_value: this.state.module_type_value_arr[index]})

		  const selectedType = lang.common.dashboard_field_options.find(
			(opt) => opt.value === this.state.module_type_value_arr[index]
			);

			this.setState({
			module_type: selectedType, // single object, not array
			module_type_value: this.state.module_type_value_arr[index],
			});

			const selectedblock = lang.common.dashboard_blocks.find(
			(opt) => opt.value === this.state.dashboard_block_arr[index]
			);

			this.setState({
			dashboard_block_sel: selectedblock ? [selectedblock] : [],
			dashboard_block: this.state.dashboard_block_arr[index],
			});
  		if(this.state.show_count_arr[index] == 'yes'){
  			this.setState({show_count : 'yes',show_count_no: false})
  		}else{
			this.setState({show_count : 'no',show_count_no: true})
  		}
  		if(this.state.select_options_arr[index]!==''){
  			this.setState({select_options:this.state.select_options_arr[index]});
  		}
		if(this.state.image_name_arr[index]){
			this.setState({image_name_single:this.state.image_name_arr[index],image_preview:''});
		}else{
			this.setState({image_name_single:'',image_preview:''});
		}
		if(this.state.bg_image_name_arr[index]){
			this.setState({db_bg_image_name:this.state.bg_image_name_arr[index],bg_image_preview:''});
		}else{
			this.setState({db_bg_image_name:'',bg_image_preview:''});
		}
		$('#addbutton').html('Update');
  }
  getformlayout(){
      var form_field_value = this.state.name_arr;
      if (Object.keys(form_field_value).length > 0) {
      const formlayout = form_field_value.map(
      (datas, Index) => {
      let indexdata = Index+1;
      return (
            <div key={Index+'list'}>
            <li className="sortablecontainer-module-list border-0 ps-0 d-flex align-item-start w-100">
            {/* <i class="fa fa-chevron-right" aria-hidden="true"></i> */}
			<p className='text-break w-75'><b>{indexdata}. </b>
            {datas}
			</p>
            <div className="sortablecontainer-module-edit-button w-25 d-flex justify-content-end gap-3">
			
			<a onClick={this.editsinglefield.bind(this,Index)}><svg height="22px" width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="64 69.27 506.72 506.72"><path d="M535.6 85.7C513.7 63.8 478.3 63.8 456.4 85.7L432 110.1L529.9 208L554.3 183.6C576.2 161.7 576.2 126.3 554.3 104.4L535.6 85.7zM236.4 305.7C230.3 311.8 225.6 319.3 222.9 327.6L193.3 416.4C190.4 425 192.7 434.5 199.1 441C205.5 447.5 215 449.7 223.7 446.8L312.5 417.2C320.7 414.5 328.2 409.8 334.4 403.7L496 241.9L398.1 144L236.4 305.7zM160 128C107 128 64 171 64 224L64 480C64 533 107 576 160 576L416 576C469 576 512 533 512 480L512 384C512 366.3 497.7 352 480 352C462.3 352 448 366.3 448 384L448 480C448 497.7 433.7 512 416 512L160 512C142.3 512 128 497.7 128 480L128 224C128 206.3 142.3 192 160 192L256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128L160 128z"></path></svg></a>
			
			<a onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}>
				<svg xmlns="http://www.w3.org/2000/svg" height="22px" width="22px" viewBox="96 48 448 528"><path d="M232.7 69.9L224 96L128 96C110.3 96 96 110.3 96 128C96 145.7 110.3 160 128 160L512 160C529.7 160 544 145.7 544 128C544 110.3 529.7 96 512 96L416 96L407.3 69.9C402.9 56.8 390.7 48 376.9 48L263.1 48C249.3 48 237.1 56.8 232.7 69.9zM512 208L128 208L149.1 531.1C150.7 556.4 171.7 576 197 576L443 576C468.3 576 489.3 556.4 490.9 531.1L512 208z"></path></svg>
			</a>

            {/* <button onClick={this.editsinglefield.bind(this,Index)} >Edit</button>
            <button onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}>Delete</button> */}
            </div>
            </li></div> );

      }
      );
      return formlayout;
      }
  }
  getdeleteall = (ids) =>{
	  this.setState({showlayout:false,name_arr:[],form_input_type_arr:[],form_input_type_value_arr:[],field_priorty_arr:[],field_required_arr:[],select_options_arr:[], field_count_size_arr: [], field_text_size_arr: [], field_text_color_arr: [], field_count_color_arr: [], field_text_size_arr: []});
	  this.setState(prevState => ({
		removeall_ids: [...prevState.removeall_ids, ids]
	  }))
  }

  handlefieldTypeChange(selectname,event) {
	console.log("=== HANDLEFIELDTYPECHANGE ===");
	console.log("selectname:", selectname);
	console.log("event object:", event);
	console.log("event.value:", event.value);
	if(selectname=='link_to') {
		console.log("Link To selected, setting value:", event.value);
		this.setState({module_type:[event],module_type_value:event.value})
	}else if(selectname=='dashboard_block') {
		console.log("Dashboard Block selected, setting value:", event.value);
       this.setState({dashboard_block_sel:[event],dashboard_block:event.value}, () => {
	   	console.log("State updated - dashboard_block is now:", this.state.dashboard_block);
	   })
	}
}

  getDisabledBlockOptions = () => {
	const { blockCounts } = this.state;
	return lang.common.dashboard_blocks.map(block => ({
		...block,
		isDisabled: blockCounts && blockCounts[block.value] !== undefined
			? blockCounts[block.value] >= block.columncount
			: false
	}));
  }

  render() {
  const {selectedOption,showlayout,login_type, image_name_single,db_bg_image_name} = this.state;
			let preview = '';
		
			if (image_name_single !=='') {
				const imagepre = mediaUrl+'dashboard/'+this.state.image_name_single;
				preview = <img className="img_class" src={imagepre} alt="" width={100} height={100}/>;
			}

			if(this.state.image_preview!==''){
					preview = <img className="img_class" src={this.state.image_preview} alt="" width={100} height={100}/>;
			}

			let bgpreview ='';

			if(db_bg_image_name !=='') {
				const bgimagepre = mediaUrl+'dashboard/'+db_bg_image_name;
				bgpreview = <img className="img_class" src={bgimagepre} alt="" width={100} height={100}/>;
			}

			if(this.state.bg_image_preview!==''){
					bgpreview = <img className="img_class" src={this.state.bg_image_preview} alt="" width={100} height={100}/>;
			}
  return (
   <div className="wrapper"> 
    <Header />
    <MenuSidebar  currentpage="dashboardmanagement" />		
    	<div className="content">	
    		<div className="content-wrapper">
			<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
    			<div className="success_message"></div>
				<a class="primary-btn" href="/dashboardmanagement">Back</a>
					<div className="title">
						<h4>Edit {this.state.login_type.value} dashboard</h4>
					</div>
    			<div className="content-body">
  			
        			<div className="builderpage-module-pagewrapper">
                <section className="builderpage-module-section">
				{this.state.name_arr.length > 0 && <> {(this.state.showlayout == true)?<> <h2 className="typography-module-title pt-4 mt-3 mb-4 text-start">{this.state.login_type_value} Menus <div className="sortablecontainer-module-delete-btn"><button onClick={this.getdeleteall.bind(this, this.state.field_ids)}>Delete All</button></div></h2>
				
                       <div className="sortablecontainer-module-wrapper">
                         <ul>
                           {this.getformlayout()}
                         </ul>
                         
                      </div></>:''}</>}
                  </section>
				  <form className="BuilderPage-module-form builderpage-module-section" onSubmit={ (e) => { e.preventDefault(); this.handleFormSubmit(this); }}>

						<div className="form-group">
							<label className='pt-4'>User Type:</label>
							<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type.value} onChange={this.handleInputChange} autoComplete="off" readOnly/>
						</div>
						{/* <div className="form-group">					
						<label>User Type :</label>
						<Select 
						value={this.state.login_type.value}
						options={lang.common.login_type} 
						onChange={this.handleChange}
						isDisabled ={true}
						/>
						</div> */}
						{/* <div className="form-group radio-check">
						<label>Choose layout</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" checked/>
								<label className="form-check-label" for="show_count_yes">
								One Column
								</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_no" />
								<label className="form-check-label" for="show_count_no">
								Two Column
								</label>
						</div> */}
						{/* <div className="form-group">					
						<label>Status:</label>
								<Select 
								value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
								options={lang.common.status_option} 
								onChange={this.handleChange}
								/>
						</div> */}
						<h2 className="typography-module-title">Add Menu</h2>
						<div className="form-group">
						<label>Title/Tooltip:</label>
						<input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} autoComplete="off" />
						<div className="errorname"></div>
						</div>
						<div className="form-group radio-check">
							<label>Show Tooltip</label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="yes" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'yes'} />
								<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="no" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'no'} />
							<label className="form-check-label" htmlFor="show_count_no"> No</label>
      					</div>
						<div className="form-group">
						<label>Link To: </label>
						<Select 
						value={this.state.module_type!=''?this.state.module_type:'Choose'}
						options={lang.common.field_options} 
						onChange={this.handlefieldTypeChange.bind(this,'link_to')}
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						<div className="form-group">
						<label>Block: </label>
						<Select
						value={this.state.dashboard_block_sel!=''?this.state.dashboard_block_sel:'Choose'}
						options={this.getDisabledBlockOptions()}
						onChange={this.handlefieldTypeChange.bind(this,"dashboard_block")}
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						{/* {(this.state.module_type_value == 'select' || this.state.module_type_value == 'checkbox' || this.state.module_type_value == 'radio')?<div className="form-group">
						<label>Options:</label>
						<input type="text" name="select_options" className="form-control" value={this.state.select_options} placeholder="Enter options separate by ," onChange={this.handleInputChange} autoComplete="off" />
						<div className="erroroptions"></div>
						</div>:''} */}
						
						{/* <div className="form-group">
							<label>Content : </label>
							<input type="text" name="content" className="form-control" value={this.state.content} placeholder="Content" onChange={this.handleInputChange} autoComplete="off" />
						</div> */}

						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Icon:</label>
									<div className="choose-file">
										{this.state.isHidden && <div className="image_success"></div>}
										<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} accept="image/*"/></span>
									</div>
									{preview && preview !== '' && <div className='d-flex gap-2'>{preview} <span className='fw-bold cursor-pointer' onClick={this.removeImagePreview}>X</span></div>}
									<div className="errorloaderimage"></div>
								</div> 
							</div> 
							<div className="col-xl-6">
								<div className="form-group">
									<label>Icon width:</label>
									<input type="text" name="icon_width" className="form-control" value={this.state.icon_width}  onChange={this.handleInputChange} autoComplete="off" />
									<div className="erroriconwidth"></div>
								</div> 
							</div>
						</div>

						{/* <div className="form-group">
							<label>Background image:</label>
							<div className="choose-file">
								{this.state.isHidden && <div className="bg_image_success"></div>}
								<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBgImgHandler} accept="image/*"/></span>
							</div>
							{bgpreview && bgpreview !== '' && <div className='d-flex gap-2'>{bgpreview} <span className='fw-bold cursor-pointer' onClick={this.removeBgImagePreview}>X</span></div>}
							<div className="errorloaderimage"></div>
						</div>  */}

						{/* <div className="form-group">
							<input className='ms-0' onChange={this.handleInputChange} type="checkbox"  name="mini_dropdown_list" 
							checked={this.state.mini_dropdown_list}/>
							<label>Dashboard List:</label>
						</div> */}
						{/* <div className="form-group radio-check">
								<label>Show Count</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" onChange={this.handleInputChange} checked={(this.state.show_count_yes == true ? "checked" : "" )}/>
								<label className="form-check-label" for="show_count_yes">
								Yes
								</label>
								<input className="form-check-input" type="radio" name="show_count" onChange={this.handleInputChange}  id="show_count_no" checked={(this.state.show_count_no == true ? "checked" : "" )} />
								<label className="form-check-label" for="show_count_no">
								No
								</label>
						</div> */}
						<div className="form-group radio-check">
								<label>Show Count</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" value="yes" onChange={this.handleInputChange} checked={this.state.show_count === 'yes'} />
									<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_no" value="no" onChange={this.handleInputChange} checked={this.state.show_count === 'no'} />
								<label className="form-check-label" htmlFor="show_count_no"> No</label>
      						</div>
						<div className="form-group">
							<label>Priority : </label>
							<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
							<div className="errorpriority"></div>
						</div>
						<div className="form-group">
							<label>Text size:</label><br></br>
							<input type="input" id="head" name="text_size" className="form-control" value={this.state.text_size} onChange={this.handleInputChange} />
							<div className="error_text_size"></div>
						</div>

						<div className="form-group">
							<label>Count size:</label><br></br>
							<input type="text" id="head" name="count_size" className="form-control" value={this.state.count_size} onChange={this.handleInputChange} />
							<div className="error_count_size"></div>
						</div>
						<div className="row">
							<div className="col-xl-6">
								<div className="form-group">
									<label>Text color:</label><br></br>
									<input type="color" id="head" name="text_color" value={this.state.text_color} onChange={this.handleInputChange} />

									<div className="error_text_color"></div>
								</div>
							</div>
							<div className="col-xl-6">
								<div className="form-group">
									<label>Count color:</label><br></br>
									<input type="color" id="head" name="count_color" value={this.state.count_color} onChange={this.handleInputChange} />

									<div className="error_count_color"></div>
								</div>
							</div>
						</div>
						<div className='product-subscription-form-row pt-4 mt-4'>
						<div className="submit-button">
						<span className="btn btn_orange btn_minwid login_submit animate-btn2" id="addbutton" onClick={this.Addtolayout}>Add</span>
						</div>
						<div className="">	
						<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
											<span className="load-data"></span> 
											}Submit
						</button>
						</div>
						</div>
						</form>
          </div>
  			</div>	
			</div>
  		</div>	
  	</div>
  </div>
  );
  }
  }

export default (withRouter(Edit));